<template>
  <v-navigation-drawer
    :value="isOpen"
    @input="onDrawerInput"
    temporary
    app
    :width="280"
    class="mobile-drawer"
  >
    <!-- En-tête -->
    <v-list-item class="px-3 py-2">
      <v-list-item-avatar size="36">
        <v-img :src="logoSrc" />
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="font-weight-bold">{{ companyName }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider />

    <!-- Liens de navigation -->
    <v-list dense nav>
      <template v-for="item in filteredTopLinks">
        <!-- Lien simple (sans enfants) -->
        <v-list-item
          v-if="!hasVisibleChildren(item)"
          :key="item.title"
          :to="item.to"
          :disabled="item.disabled"
          @click="onItemClick"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Groupe avec sous-liens -->
        <v-list-group
          v-else
          :key="'g-' + item.title"
          no-action
          append-icon="mdi-chevron-down"
          :value="false"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="child in filteredChildren(item)"
            :key="child.title"
            :to="child.to"
            class="pl-8"
            @click="onItemClick"
          >
            <v-list-item-content>
              <v-list-item-title>{{ $t(child.title) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </template>
    </v-list>

    <!-- Liens du bas (Équipe, etc.) -->
    <template v-slot:append>
      <div v-if="filteredBottomLinks.length">
        <v-divider />
        <v-list dense nav>
          <v-list-item
            v-for="item in filteredBottomLinks"
            :key="item.title"
            :to="item.to"
            :disabled="item.disabled"
            @click="onItemClick"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import {
  PROJECT_DRAWER_TOP,
  PROJECT_DRAWER_BOTTOM,
  CLIENT_DRAWER_TOP,
  ADMIN_DRAWER_TOP,
  ADMINISTRATION_DRAWER_TOP,
  TEMPLATE_DRAWER_TOP
} from "@/utils/links"

export default {
  name: "AppDrawer",
  props: {
    isOpen: { type: Boolean, default: false },
    isMobile: { type: Boolean, default: false }
  },
  computed: {
    logoSrc() {
      const isDark = this.$store.state.app.isThemeDark
      return isDark
        ? this.$appConfig.assets.img.custom.icon_logo_white
        : this.$appConfig.assets.img.custom.icon_logo
    },
    companyName() {
      return this.$store.state.app.company?.name || "GWASSOU"
    },
    hasRouteDrawer() {
      return !!this.$route.meta?.drawer
    },
    topLinks() {
      if (!this.hasRouteDrawer) {
        return [
          { to: { name: "Home" }, title: "Tableau de bord", icon: "mdi-home" },
          { to: { name: "CompanyDepartment" }, title: "Départements", icon: "mdi-apps" }
        ]
      }

      const path = this.$route.path

      // Administration (user management) — vérifier avant /admin
      if (path.startsWith("/administration")) {
        return ADMINISTRATION_DRAWER_TOP
      }
      // Admin (super admin)
      if (path.startsWith("/admin")) {
        return ADMIN_DRAWER_TOP
      }
      // Templates / formulaires
      if (path.startsWith("/forms")) {
        return TEMPLATE_DRAWER_TOP
      }

      // Project (défaut) — selon le type de société
      const companyType = this.$store.getters["app/getCompany"]?.company_type
      return companyType === "Partners" ? CLIENT_DRAWER_TOP : PROJECT_DRAWER_TOP
    },
    bottomLinks() {
      if (!this.hasRouteDrawer) return []

      const path = this.$route.path
      if (path.startsWith("/administration") || path.startsWith("/admin") || path.startsWith("/forms")) {
        return []
      }

      return PROJECT_DRAWER_BOTTOM
    },
    filteredTopLinks() {
      return this.topLinks.filter(link =>
        link.isAllowed ? link.isAllowed(this) : true
      )
    },
    filteredBottomLinks() {
      return this.bottomLinks.filter(link =>
        link.isAllowed ? link.isAllowed(this) : true
      )
    }
  },
  methods: {
    filteredChildren(item) {
      if (!item.children) return []
      return item.children.filter(child =>
        child.isAllowed ? child.isAllowed(this) : true
      )
    },
    hasVisibleChildren(item) {
      return item.children && this.filteredChildren(item).length > 0
    },
    onDrawerInput(val) {
      this.$emit("toggle", val)
    },
    onItemClick() {
      this.$emit("toggle", false)
    }
  }
}
</script>

<style scoped>
.mobile-drawer {
  z-index: 1000;
}
</style>
